/**
 * After sign-out, the marketing site logo can still send users to `/recent` for a limited time.
 * Guests who never signed in never get a deadline key → quick entry stays available until they sign out later.
 */

export const MARKETING_QUICK_ENTRY_UNTIL_KEY = 'corner:marketing-quick-entry-until';

/** Default: 30 days from sign-out until the logo behaves like a cold visitor (`/` only). */
export const MARKETING_QUICK_ENTRY_AFTER_SIGNOUT_MS = 30 * 24 * 60 * 60 * 1000;

export function refreshMarketingQuickEntryAfterSignOut(): void {
  try {
    localStorage.setItem(
      MARKETING_QUICK_ENTRY_UNTIL_KEY,
      String(Date.now() + MARKETING_QUICK_ENTRY_AFTER_SIGNOUT_MS),
    );
  } catch {
    /* ignore */
  }
}

export function clearMarketingQuickEntryDeadline(): void {
  try {
    localStorage.removeItem(MARKETING_QUICK_ENTRY_UNTIL_KEY);
  } catch {
    /* ignore */
  }
}

const MIGRATION_MQE_V1_KEY = 'corner:migration-marketing-quick-entry-v1';

/**
 * One-time: browsers that already had `onboarding-complete` before quick-entry existed had no
 * deadline and kept logo → `/recent` forever. Seed the same TTL window from first load after deploy.
 * Guests can clear the deadline again via “Continue without account” (or sign-in).
 */
export function runMarketingQuickEntryMigrationOnce(): void {
  if (typeof window === 'undefined') return;
  try {
    if (localStorage.getItem(MIGRATION_MQE_V1_KEY) === '1') return;
    if (localStorage.getItem('corner:onboarding-complete') !== '1') return;
    if (localStorage.getItem(MARKETING_QUICK_ENTRY_UNTIL_KEY) != null) return;

    localStorage.setItem(
      MARKETING_QUICK_ENTRY_UNTIL_KEY,
      String(Date.now() + MARKETING_QUICK_ENTRY_AFTER_SIGNOUT_MS),
    );
    localStorage.setItem(MIGRATION_MQE_V1_KEY, '1');
  } catch {
    /* ignore */
  }
}

/** True when onboarding is done and quick entry from marketing has not expired. */
export function canOpenAppFromMarketingLogo(): boolean {
  if (typeof window === 'undefined') return false;
  if (localStorage.getItem('corner:onboarding-complete') !== '1') return false;
  const raw = localStorage.getItem(MARKETING_QUICK_ENTRY_UNTIL_KEY);
  if (raw == null) return true;
  const until = parseInt(raw, 10);
  if (Number.isNaN(until)) return true;
  return Date.now() < until;
}
